import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { statementsList, adminStatementsList, FetchSecurityMaster } from "../../api/api";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import _ from "lodash";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const Statements = () => {
  const [data, setData] = useState<any>([]);
  const [adminStatementsData, setAdminStatementsData] = useState<any>([]);
  const [selectedStatmenttype, setSelectedStatmenttype] = useState("");
  const selectedClient: any = Cookies.get("client");
  useEffect(() => {
    const payload = {
      //date: "2023-06-23T12:50:20.523Z",
      //type: "Fund Report",
      pageNumber: 1,
      pageSize: 200,
    };
    statementsList(
      payload,
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response)
      .then((response) => {
        setData(response);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const payload = {
      // Type: "Fund Report 12334",
      // Date: "2023-06-05",
      PageNumber: 1,
      PageSize: 200,
    };
    adminStatementsList(payload, parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response)
      .then((response) => {
        setAdminStatementsData(response);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const statementType = _.uniqBy(data, "statementType");
  const filteredStatementType = _.filter(data, {
    statementType: selectedStatmenttype,
  });

  
  const [columns, setColumns] = useState([
    {
      headerName: "Name",
      field: "name",
      flex: 1,
      headerClass: "px-4",
      //cellStyle: { left: "10px" },
      floatingFilter: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Statement Type",
      field: "type",
      sortable: true,
      //width: 140,
      floatingFilter: true,
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Date",
      field: "date",
      sortable: true,
      //width: 100,
      floatingFilter: true,
      filter: "agDateColumnFilter",
    },
    {
      headerName: "Statement",
      field: "date",
      sortable: true,
      //width: 150,
      cellRendererFramework: (params: any) => {
        return (
          <>
            <span className="cursor-pointer ml-4">
              <a href={params.data.filePath} target="_blank">
                View/ Download{" "}
                <i title="delete" className="fas fa-fw fa-file-pdf"></i>
              </a>
            </span>
          </>
        );
      },
    },
  ]);

  const [adminColumns, setAdminColumns] = useState([
    {
      headerName: "Fund",
      field: "fund",
      width: 100,
      headerClass: "px-4",
      //cellStyle: { left: "10px" },
      floatingFilter: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Participant Name",
      field: "participantName",
      width: 150,
      headerClass: "px-4",
      //cellStyle: { left: "10px" },
      floatingFilter: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Name",
      field: "name",
      flex: 1,
      headerClass: "px-4",
      //cellStyle: { left: "10px" },
      floatingFilter: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Statement Type",
      field: "type",
      sortable: true,
      //width: 140,
      floatingFilter: true,
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Date",
      field: "date",
      sortable: true,
      //width: 100,
      floatingFilter: true,
      filter: "agDateColumnFilter",
    },
    {
      headerName: "Statement",
      field: "date",
      sortable: true,
      //width: 150,
      cellRendererFramework: (params: any) => {
        return (
          <>
            <span className="cursor-pointer ml-4">
              <a href={params.data.filePath} target="_blank">
                View/ Download{" "}
                <i title="delete" className="fas fa-fw fa-file-pdf"></i>
              </a>
            </span>
          </>
        );
      },
    },
  ]);
  
  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Statements</h1>
      </div>
      <div className="row w-100 card py-4 px-0">
        <Tabs>
          <TabList>
            <Tab>Statements</Tab>
            <Tab>Admin Statements</Tab>
          </TabList>

          <TabPanel>
            
            <div
              className="ag-theme-alpine"
              style={{
                height: "500px",
                width: "100%",
              }}
            >
              <AgGridReact
                rowData={data?.items}
                columnDefs={columns}
                animateRows={true}
                domLayout={"normal"}
                pagination={true}
                paginationPageSize={20}
                className="px-2"
                //paginationAutoPageSize={true}
              ></AgGridReact>
            </div>
          </TabPanel>
          <TabPanel>
            <div
              className="ag-theme-alpine"
              style={{
                height: "500px",
                width: "100%",
              }}
            >
              <AgGridReact
                rowData={adminStatementsData?.items}
                columnDefs={adminColumns}
                animateRows={true}
                domLayout={"normal"}
                pagination={true}
                paginationPageSize={20}
                className="px-2"
                //paginationAutoPageSize={true}
              ></AgGridReact>
            </div>
          </TabPanel>
        </Tabs>

        
      </div>
    </div>
  );
};

export { Statements };
